export const stationKeys = {
	all: ['mantang', 'stations'] as const,
	list: () => [...stationKeys.all, 'list'] as const,
	detail: (stationId: string) => [...stationKeys.all, stationId] as const,
	regionPrice: (lat?: number, lng?: number) =>
		[...stationKeys.all, 'regionPrice', lat, lng] as const,
};
